import StoreHolder from './storeHolder';
import type { AppDispatch } from './store';

export function useDispatch(): AppDispatch {
  return StoreHolder.getStore().dispatch;
}
